const animationClassNames = [
  'to-top'
];

// 一次性生成选择器并查询
const animateElements = document.querySelectorAll(
  animationClassNames.map(cls => `.${cls}`).join(',')
);

if (animateElements.length > 0) {

  // ------------------------
  // 工具函数
  // ------------------------
  const retriggerAnimation = el => {
    el.classList.remove('appear');
    void el.offsetWidth; // 强制 reflow
    el.classList.add('appear');
  };

  const startShakeAnimation = el => {
    el.__shakeInterval = setInterval(() => {
      retriggerAnimation(el);
    }, 3000);
  };

  const triggerOnceAnimation = el => {
    requestAnimationFrame(() => el.classList.add('appear'));
  };

  // ------------------------
  // Intersection Observer
  // ------------------------
  const observer = new IntersectionObserver((entries, obs) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;

      const el = entry.target;

      if (el.classList.contains('shake-once')) {
        startShakeAnimation(el);
      } else {
        triggerOnceAnimation(el);
      }

      obs.unobserve(el);
    }
  }, {
    root: null,
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
  });

  // ------------------------
  // 批次观察（更节省内存）
  // ------------------------
  const observeInBatches = (elements, batchSize = 20) => {
    let index = 0;

    const runBatch = () => {
      const limit = Math.min(index + batchSize, elements.length);

      for (let i = index; i < limit; i++) {
        observer.observe(elements[i]);
      }

      index = limit;

      if (index < elements.length) {
        (window.requestIdleCallback || (cb => setTimeout(cb, 150)))(runBatch);
      }
    };

    runBatch();
  };

  // 初始化
  observeInBatches(animateElements);
}




document.addEventListener('click', function(event) {
    // 1. 判断是否点击了标签名称
    const trigger = event.target.closest('.product-tag-desc_name');
    
    if (trigger) {
        event.preventDefault();
        event.stopPropagation(); // 阻止冒泡，防止触发底部的全局关闭逻辑

        // 获取需要打开的弹窗对应的 class 名称
        const targetClassName = trigger.getAttribute('data-name');
        
        // 找到当前点击的商品最外层容器，只在这个容器里操作
        // 这样就算不同商品都有 '-1' 的 class，也绝对不会互相影响
        const wrapper = trigger.closest('.product-tag-desc');
        if (!wrapper) return;
        
        // 在当前商品下寻找对应的弹窗内容
        const targetContent = wrapper.querySelector(`.${targetClassName}`);
        const allContents = wrapper.querySelectorAll('.product-tag-desc_content');

        // 隐藏当前商品下的其他弹窗
        allContents.forEach(item => {
            if (item !== targetContent) {
                item.style.display = 'none';
            }
        });

        // 切换当前点击的弹窗显示状态
        if (targetContent) {
            targetContent.style.display = (targetContent.style.display === 'none' || targetContent.style.display === '') ? 'block' : 'none';
        }
        return; 
    }

    // 2. 判断是否点击了弹窗内部，如果是，则阻止冒泡，不执行关闭操作
    const isInsideContent = event.target.closest('.product-tag-desc_content');
    if (isInsideContent) {
        event.stopPropagation();
        return;
    }

    // 3. 点击页面的其他空白区域时，隐藏全页面所有的弹窗
    document.querySelectorAll('.product-tag-desc_content').forEach(block => {
        block.style.display = 'none';
    });
});